import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { connectRouter } from 'connected-react-router';
import { reducers as authenticationReducer } from '@saucelabs/sl-container-authentication';
import { reducers as confirmAlertReducer } from '@saucelabs/sl-container-confirm-alert';
import { reducers as notificationsReducer } from '@saucelabs/sl-container-notifications';
import { reducers as permissionsReducer } from '@saucelabs/sl-container-permissions';
import { reducers as sidebarReducer } from '@saucelabs/sl-container-sidebar';
import { reducers as modalReducer } from '@saucelabs/sl-container-modal';
import { reducers as toolbarReducer } from '@saucelabs/sl-container-toolbar';
import { reducers as errorPagesReducer } from '@saucelabs/sl-container-error-pages';
import { reducers as concurrencyReducer } from '@saucelabs/sl-module-concurrency';
import { reducers as experimentsReducer } from '@saucelabs/sl-module-experiments';
import { reducers as userTunnelsReducer } from '@saucelabs/sl-module-tunnels';
import { reducers as rdcTunnelsReducer } from '@saucelabs/sl-module-tunnels-rdc';
import { reducers as userReducer } from '@saucelabs/sl-module-user';
import { reducers as userRdcReducer } from '@saucelabs/sl-module-user-rdc';
import { reducers as performanceReducer } from '@saucelabs/sl-module-performance';
// apps specific reducers
import analyticsReducer from '@saucelabs/web-ui-analytics/src/reducers';
import archivesReducer from '@saucelabs/web-ui-archives/src/reducers';
import authReducer from '@saucelabs/web-ui-auth/src/ducks/reducers';
import invitationsReducer from '@saucelabs/web-ui-invitations/src/reducers';
import buildsReducer from '@saucelabs/web-ui-builds/src/reducers';
import jobReducer from '@saucelabs/web-ui-job-details/src/reducers';
import jobsReducer from '@saucelabs/web-ui-jobs/src/reducers';
import manualReducer from '@saucelabs/web-ui-manual/src/reducers';
import migrationWiardReducer from '@saucelabs/web-ui-migration-wizard/src/reducers';
import teamManagementReducer from '@saucelabs/web-ui-team-management/src/reducers';
import tunnelsReducer from '@saucelabs/web-ui-tunnels/src/reducers';
import extendedDebuggingReducer from '@saucelabs/web-ui-extended-debugging/src/reducers';

import applicationReducer from './application/reducers';

const apps = combineReducers({
  analytics: analyticsReducer,
  app: applicationReducer,
  archives: archivesReducer,
  auth: authReducer,
  invitations: invitationsReducer,
  builds: buildsReducer,
  job: jobReducer,
  jobs: jobsReducer,
  manual: manualReducer,
  migrationWizard: migrationWiardReducer,
  teamManagement: teamManagementReducer,
  tunnels: tunnelsReducer,
  performance: performanceReducer,
  extendedDebugging: extendedDebuggingReducer,
});

const createReducer = (history) => combineReducers({
  // react & redux 3rd party libs
  router: connectRouter(history),
  form: formReducer,

  // cross package stuff
  confirmedAlerts: confirmAlertReducer,
  modal: modalReducer,
  notifications: notificationsReducer,
  sidebar: sidebarReducer,
  errorPage: errorPagesReducer,
  toolbar: toolbarReducer,

  // FIXME: should be cleaned and moved into `me` key at the top level of store
  // currently logged user
  experiments: experimentsReducer,
  permissions: permissionsReducer,
  user: authenticationReducer,
  userRdc: userRdcReducer,
  userData: userReducer,
  userConcurrency: concurrencyReducer,
  userTunnels: userTunnelsReducer,
  rdcTunnels: rdcTunnelsReducer,

  // packages specific store
  apps,
});

export default createReducer;
